<template>
  <div id="app">
    <div id="content">
      <div id="content-main" class="ms-Fabric" >
        <div class="ms-Grid" dir="ltr" v-show="!loading">
          <div v-show="!missing_contacts && error.visitors !== true">
            <div class="ms-Grid-row">
              <div class="ms-Grid-col ms-sm6 ms-md4 ms-lg2 full-col">
                <div v-show="visit==null">
                  <button class="ms-Button"
                          v-on:click="CreateVisit">
                    <span class="ms-Button-label"><translate>Create Entrant Visit</translate></span>
                  </button>
                </div>
                <div v-show="visit!=null">
                  <button class="ms-Button"
                          v-on:click="UpdateVisit">
                    <span class="ms-Button-label"><translate>Update Entrant Visit</translate></span>
                  </button>
                </div>
              </div>
            </div> <!-- row -->
            <div class="ms-Grid-row" v-show="attendees.length>1">
              <div class="ms-Grid-col ms-sm6 ms-md4 ms-lg2 full-col">
                <div v-if="visit!=null">
                  <button class="ms-Button"
                          v-on:click="SendWelcomeEmail">
                    <span class="ms-Button-label"><translate>Send Welcome Email</translate></span>
                  </button>
                </div>
              </div>
            </div> <!-- row -->
            <div class="ms-Grid-row" v-show="attendees.length==1">
              <div class="ms-Grid-col ms-sm6 ms-md4 ms-lg2 full-col">
                <div v-if="visit!=null">
                  <button class="ms-Button"
                          v-on:click="AddWelcomeMessage">
                    <span class="ms-Button-label"><translate>Add Welcome Message in Body</translate></span>
                  </button>
                </div>
              </div>
            </div> <!-- row -->
            <div class="ms-Grid-row" v-if="(locations && !loading && templates)">
              <ou-dropdown
                v-model='template'
                label='Template'>
                <ou-dropdown-item
                  v-for="template in templates"
                  v-bind:key="template.id"
                  :value='template.id.toString()'>{{ template.name }}</ou-dropdown-item>
              </ou-dropdown>
            </div> <!-- row -->
          </div>
          <div class="ms-Grid-row" v-show="Object.keys(error)!=0 && !missing_contacts">
            <div class="ms-Grid-col ms-sm6 ms-md4 ms-lg2">
              <div class="ms-MessageBar ms-MessageBar--error"
                v-show ="error.location">
                <div class="ms-MessageBar-content">
                  <div class="ms-MessageBar-icon">
                    <i class="ms-Icon ms-Icon--ErrorBadge"></i>
                  </div>
                  <div class="ms-MessageBar-text">
                    <translate>No valid Location chosen</translate>
                    <br />
                  </div>
                </div>
              </div> <!-- MessageBar -->
              <div class="ms-MessageBar ms-MessageBar--error"
                v-show ="error.visitors && !missing_contacts">
                <div class="ms-MessageBar-content">
                  <div class="ms-MessageBar-icon">
                    <i class="ms-Icon ms-Icon--ErrorBadge"></i>
                  </div>
                  <div class="ms-MessageBar-text">
                    <translate>Please add your visitors</translate>
                    <br />
                  </div>
                </div>
              </div> <!-- MessageBar -->
            </div>
          </div> <!-- row -->
          <ou-message-bar icon='Info' type='warning' v-show="missing_data.length > 0">
            The following attendees are missing data:
          </ou-message-bar>
          <div v-for="contact in missing_data" v-bind:key="contact.Id">
            <contact :contact=contact v-on:updateContact="updateContact">
            </contact>
          </div>
        </div> <!-- ms-Grid -->
        <div v-show="loading || missing_contacts">
          <ou-spinner type="Large" label="Loading">
          </ou-spinner>
        </div>
        <div class="">
          {{ debug }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import '@babel/polyfill'
import axios from 'axios'
import Q from 'q'
import GetTextPlugin from 'vue-gettext'
import translations from '../translations.json'
import Contact from './components/Contact'
import {CodeToName} from './components/Language.js'
import OfficeUIFabricVue from 'office-ui-fabric-vue'

// import css style
import 'office-ui-fabric-vue/dist/index.css'

export default {
  name: 'App',
  components: {
    Contact,
  },
  data () {
    return {
      item: 'default',
      loading: true,
      created: false,
      updating: false,
      sendVisit: false,
      subject: '',
      accessToken: undefined,
      attendees: [],
      optionalAttendees: [],
      visitors: undefined,
      contacts: [],
      itemId: undefined,
      visit: undefined,
      location: 'unknown!',
      templates: undefined,
      template: undefined,
      waitingForToken: false,
      createdContacts: [],
      missing_data: [],
      error: {},
      debug: '',
    }
  },
  mounted () {
    var self = this
    Vue.use(OfficeUIFabricVue)

    self.item = window.Office.context.mailbox.item
    self.host_email = window.Office.context.mailbox.userProfile.emailAddress

    window.Office.onReady(function () {
      Vue.use(GetTextPlugin, {translations: translations})
      var myLanguage = window.Office.context.displayLanguage
      Vue.config.language = myLanguage

      axios
        .get('https://outlook.entrant.io/domains.json')
        .then(function (response) {
          var domain = self.host_email.replace(/.*@/, '').toLowerCase()
          self.server = response.data[domain]
          self.UpdateVisit()
        })

      // window.Office.context.mailbox.addHandlerAsync(
      // window.Office.EventType.ItemChanged,
      // function (event) { console.log('ItemChanged') },
      // )
    })
    setInterval(function () {
      // update data every 1000 ms
      self.updateData()
        .then(function (value) {
          self.updating = false
          if (self.sendVisit === true) {
            self.SendVisitData()
          }
        }, function (error) {
          if (error !== '' && error !== undefined) {
            console.error(JSON.stringify(error))
          }
          self.updating = false
        })
    }, 1000)
  },
  methods: {
    updateData: function () {
      var self = this

      return Q.Promise(function (resolve, reject, notify) {
        if (self.updating === true) {
          reject()
        }
        self.updating = true
        self.item = window.Office.context.mailbox.item

        var promises = []

        var deferredLocation = Q.defer()
        promises.push(deferredLocation.promise)
        self.item.location.getAsync(function (asyncResult) {
          if (asyncResult.status === 'succeeded') {
            self.location = asyncResult.value
          } else {
            console.error('Unable to get location')
            console.error(asyncResult)
          }
          deferredLocation.resolve(true)
        })

        var deferredStart = Q.defer()
        promises.push(deferredStart.promise)
        self.item.start.getAsync(function (asyncResult) {
          if (asyncResult.status === 'succeeded') {
            self.start = asyncResult.value
          } else {
            console.error('Unable to get start time')
            console.error(asyncResult)
          }
          deferredStart.resolve(true)
        })

        var deferredEnd = Q.defer()
        promises.push(deferredEnd.promise)
        self.item.end.getAsync(function (asyncResult) {
          if (asyncResult.status === 'succeeded') {
            self.end = asyncResult.value
          } else {
            console.error('Unable to get end time')
            console.error(asyncResult)
          }
          deferredEnd.resolve(true)
        })

        var deferredSubject = Q.defer()
        promises.push(deferredSubject.promise)
        self.item.subject.getAsync(function (asyncResult) {
          if (asyncResult.status === 'succeeded') {
            self.subject = asyncResult.value
          } else {
            console.error('Unable to get subject')
            console.error(asyncResult)
          }
          deferredSubject.resolve(true)
        })

        var deferredAttendees = Q.defer()
        promises.push(deferredAttendees.promise)
        self.item.requiredAttendees.getAsync(function (asyncResult) {
          if (asyncResult.status === 'succeeded') {
            self.requiredAttendees = asyncResult.value
          } else {
            console.error('Unable to get attendees')
            console.error(asyncResult)
          }
          deferredAttendees.resolve(true)
        })

        var deferredOptionalAttendees = Q.defer()
        promises.push(deferredOptionalAttendees.promise)
        self.item.optionalAttendees.getAsync(function (asyncResult) {
          if (asyncResult.status === 'succeeded') {
            self.optionalAttendees = asyncResult.value
          } else {
            console.error('Unable to get optional attendees')
            console.error(asyncResult)
          }
          deferredOptionalAttendees.resolve(true)
        })

        var deferredAccessToken = Q.defer()
        promises.push(deferredAccessToken.promise)
        self.waitingForToken = true
        window.Office.context.auth.getAccessTokenAsync(function (result) {
          self.waitingForToken = false
          if (result.status === 'succeeded') {
            self.accessToken = result.value
            self.authorization = 'JWT ' + self.accessToken
            deferredAccessToken.resolve(true)
          } else {
            var options = {isRest: true}
            window.Office.context.mailbox.getCallbackTokenAsync(options, function (result) {
              if (result.status === 'succeeded') {
                self.callbackToken = result.value
                self.authorization = 'EXJWT ' + self.callbackToken
                deferredAccessToken.resolve(false)
              } else {
                console.error('No callback token')
                console.error(result)
                deferredAccessToken.resolve(false)
              }
            })
          }
        })

        Q.allSettled(promises)
          .then(function () {
            Step2()
          })
          .catch(function (error) {
            console.error(JSON.stringify(error))
          })

        function Step2 (results) {
          var filtered = self.requiredAttendees.filter(function (value, index, arr) {
            return value.emailAddress !== self.host_email
          })
          self.attendees = filtered

          self.itemId = self.itemId || window.Office.context.mailbox.item.itemId

          if (self.itemId === null || self.itemId === undefined) {
            if (window.Office.context.mailbox.item.getItemIdAsync) {
              window.Office.context.mailbox.item.getItemIdAsync(function (result) {
                self.itemId = result.value
                Step2n1()
              })
            } else {
              // Unable to load itemId (api lower than 1.8)
              Step2n1()
            }
          } else {
            Step3()
          }
        }
        function Step2n1 () {
          if ((self.itemId === null || self.itemId === undefined) && self.created) {
            self.created = false
            // Only run when the meeting is not yet crated but the CreateVisit button
            // has been pressed.
            // Clear attendees
            var promises = []
            var clearRequired = Q.defer()
            promises.push(clearRequired.promise)
            self.item.requiredAttendees.setAsync([], function (result) {
              clearRequired.resolve(true)
            })
            var clearOptional = Q.defer()
            promises.push(clearOptional.promise)
            self.item.optionalAttendees.setAsync([], function (result) {
              clearOptional.resolve(true)
            })

            Q.allSettled(promises)
              .then(function () {
                // Save meeting
                window.Office.context.mailbox.item.saveAsync(function (result) {
                  self.itemId = result.value
                  Step2n2()
                })
              })
              .catch(function (error) {
                console.error(JSON.stringify(error))
              })
          } else {
            Step3()
          }
        }
        function Step2n2 () {
          // Reset attendees
          var promises = []
          var optionalList = []
          for (var i = 0; i < self.optionalAttendees.length; i++) {
            optionalList.push(self.optionalAttendees[i].emailAddress)
          }
          promises.push(
            self.item.optionalAttendees.setAsync(optionalList)
          )
          var requiredList = []
          for (i = 0; i < self.attendees.length; i++) {
            requiredList.push(self.attendees[i].emailAddress)
          }
          promises.push(
            self.item.requiredAttendees.setAsync(requiredList)
          )
          Q.allSettled(promises)
            .then(function (results) {
              Step3()
            })
        }
        function Step3 () {
          self.loadContacts()
            .then(function () {
              self.getVisit()
                .then(function () {
                  Step4()
                }, function (error) {
                  console.error('Unable to get Visit')
                  console.error(error)
                })
            }, function (error) {
              console.error('Unable to load contacts')
              console.error(error)
            })
        }

        function Step4 () {
          if (self.visitors === undefined || self.visitors === null) {
            self.loadVisitors()
              .then(function () {
                self.loadLocations().then(function () {
                  self.loadTemplates().then(function () {
                    resolve('step4 done')
                  })
                })
              })
              .catch(function (error) {
                console.error(JSON.stringify(error))
                resolve('step4 error')
              })
          } else {
            self.UpdateVisitors()
            resolve('Step4 done')
          }
        }
      })
    },
    loadVisitors: function () {
      var self = this
      return Q.Promise(function (resolve, reject, notify) {
        axios.get('https://' + self.server + '/api/v1/visitors/', {
          headers: {'Authorization': self.authorization},
        })
          .then(function (response) {
            self.visitors = response.data.results
            self.UpdateVisitors()
            resolve()
          })
          .catch(function (error) {
            console.error(JSON.stringify(error))
            reject()
          })
      })
    },
    IdToName: function (locationId) {
      var self = this
      var location = self.locations.find((location) => {
        return location.id === locationId
      })
      return location.name
    },
    loadTemplates: function () {
      var self = this
      return Q.Promise(function (resolve, reject, notify) {
        axios.get('https://' + self.server + '/api/v1/welcometemplates/', {
          headers: {'Authorization': self.authorization},
        })
          .then(function (response) {
            var templates = response.data.results
            for (var i = 0; i < templates.length; i++) {
              var name = self.IdToName(templates[i].location)
              name = name + ' - ' + CodeToName(templates[i].language).nativeName
              templates[i].name = name
            }
            self.templates = templates
            self.template = self.visit.template.toString()

            resolve()
          })
          .catch(function (error) {
            console.error(JSON.stringify(error))
            reject()
          })
      })
    },
    loadLocations: function () {
      var self = this
      return Q.Promise(function (resolve, reject, notify) {
        axios.get('https://' + self.server + '/api/v1/locations/', {
          headers: {'Authorization': self.authorization},
        })
          .then(function (response) {
            self.locations = response.data.results
            resolve()
          })
          .catch(function (error) {
            console.error(JSON.stringify(error))
            reject()
          })
      })
    },
    loadContacts: function () {
      var self = this
      return Q.Promise(function (resolve, reject, notify) {
        var options = {isRest: true}
        window.Office.context.mailbox.getCallbackTokenAsync(options, function (result) {
          if (result.status === 'succeeded') {
            self.callbackToken = result.value

            self.contacts = []
            self.contactsLoaded = false
            self.getFolders()
              .then(function (result) {
                var folders = result.data.value
                var allAttendees = self.attendees.concat(self.optionalAttendees)
                var missingEmails = []
                var contactPromises = []
                for (var i = 0; i < allAttendees.length; i++) {
                  if (allAttendees[i].emailAddress === self.host_email) {
                    continue
                  }
                  contactPromises.push(
                    self.getContact(allAttendees[i].emailAddress, folders)
                  )
                }
                Q.allSettled(contactPromises)
                  .then(function (results) {
                    self.missing_contacts = false
                    for (var i = 0; i < results.length; i++) {
                      if (results[i].value === false) {
                        self.missing_contacts = true
                        missingEmails.push(allAttendees[i].emailAddress)
                      } else {
                        self.contacts.push(results[i].value)
                      }
                    }
                    self.contactsLoaded = true
                    if (missingEmails.length === 0) {
                      resolve()
                      return
                    }
                    self.getFolderId(folders)
                      .then(function (result) {
                        // var promises = []
                        for (var i = 0; i < missingEmails.length; i++) {
                          // promises.push(self.createContact(missingEmails[i]))
                          self.createdContacts.push(self.createContact(missingEmails[i]))
                        }
                        /*
                        Q.allSettled(promises)
                          .then(function (results) {
                         */
                        for (i = 0; i < results.length; i++) {
                          self.createdContacts.push(results[i].value.data)
                        }
                        missingEmails = []
                        self.missing_contacts = false
                        resolve()
                        // })
                      }, function (error) {
                        console.error('getFolderId error')
                        console.error(error)
                        reject()
                      })
                  }, function (error) {
                    console.error(error)
                    reject()
                  })
                  .catch(function (error) {
                    console.error(error)
                    reject()
                  })
              }, function (error) {
                console.error('Failed to get Folder')
                console.error(error)
                reject()
              })
          } else {
            console.error('No callback token')
            console.error(result)
            reject()
          }
        })
      })
    },
    getContact: function (email, folders) {
      var self = this
      return Q.Promise(function (resolve, reject, notify) {
        var promises = []
        for (var i = 0; i < folders.length; i++) {
          var getContactUrl = window.Office.context.mailbox.restUrl +
            '/v2.0/me/contactfolders/' + folders[i].Id +
            '/contacts/?$filter=emailAddresses/any(a:a/address eq \'' +
            email + '\')'
          promises.push(axios
            .get(getContactUrl, {
              headers: {
                'Authorization': 'Bearer ' + self.callbackToken,
                'Cache-Control': 'no-cache',
              },
            }))
        }
        getContactUrl = window.Office.context.mailbox.restUrl +
          '/v2.0/me/contacts/?$filter=emailAddresses/any(a:a/address eq \'' +
          email + '\')'
        promises.push(
          axios.get(getContactUrl, {
            headers: {
              'Authorization': 'Bearer ' + self.callbackToken,
              'Cache-Control': 'no-cache',
            },
          }))
        Q.allSettled(promises)
          .then(function (results) {
            for (var i = 0; i < results.length; i++) {
              if (results[i].value.data.value.length > 0) {
                resolve(results[i].value.data.value[0])
              }
            }
            for (var j = 0; j < self.createdContacts.length; j++) {
              if (self.createdContacts[j] === undefined) {
                continue
              }
              if (email === self.createdContacts[j].EmailAddresses[0].Address) {
                resolve(self.createdContacts[j])
              }
            }
            resolve(false)
          }, function (error) {
            console.error('error')
            console.error(error)
            reject()
          })
      })
    },
    getFolderId: function (folders) {
      var self = this
      return Q.Promise(function (resolve, reject, notify) {
        for (var i = 0; i < folders.length; i++) {
          if (folders[i].DisplayName === 'Entrant') {
            self.folderId = folders[i].Id
            resolve(folders[i].Id)
            return
          }
        }
        resolve(false)
        /*
        // No folder found. Create a new one
        self.createContactFolder()
          .then(function (result) {
            self.folderId = result.data.Id
            resolve(result.data.Id)
          })
          */
      })
    },
    getFolders: function () {
      var self = this
      var getContactUrl = window.Office.context.mailbox.restUrl +
        '/v2.0/me/contactFolders/'
      return axios({
        method: 'get',
        url: getContactUrl,
        headers: {
          'Authorization': 'Bearer ' + self.callbackToken,
          'Access-Control-Allow-Headers': 'x-requested-with',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
        },
      })
    },
    createContactFolder: function () {
      var self = this
      var getContactUrl = window.Office.context.mailbox.restUrl +
        '/v2.0/me/contactFolders/'

      return axios({
        method: 'post',
        url: getContactUrl,
        headers: {
          'Authorization': 'Bearer ' + self.callbackToken,
          'Content-Type': 'application/json',
        },
        data: {
          'DisplayName': 'Entrant',
        },
      })
    },
    createContact: function (email) {
      // var self = this
      var data = {
        'GivenName': email,
        'EmailAddresses': [
          {
            'Address': email,
            'Name': email,
          },
        ],
        'BusinessPhones': [],
        'CompanyName': '',
        'Surname': '',
      }
      return data

      /*
      var getContactUrl = window.Office.context.mailbox.restUrl +
        '/v2.0/me/contactFolders/' + self.folderId + '/contacts'

      return axios({
        method: 'post',
        url: getContactUrl,
        headers: {
          'Authorization': 'Bearer ' + self.callbackToken,
          'Content-Type': 'application/json',
        },
        data: {
          'GivenName': email,
          'EmailAddresses': [
            {
              'Address': email,
              'Name': email,
            },
          ],
        },
      })
      */
    },
    updateContact: function (contact) {
      var self = this
      /*
      var getContactUrl = window.Office.context.mailbox.restUrl +
        '/v2.0/me/contactFolders/' + self.folderId + '/contacts/' +
        contact.Id

      return axios({
        method: 'patch',
        url: getContactUrl,
        headers: {
          'Authorization': 'Bearer ' + self.callbackToken,
          'Content-Type': 'application/json',
        },
        data: contact,
      })
      */
      axios
        .get('https://' + self.server + '/api/v1/visitors/', {
          headers: {'Authorization': self.authorization},
        })
        .then(function (response) {
          var visitors = response.data.results
          for (var i = 0; i < visitors.length; i++) {
            var visitor = self.visitors[i]
            if (visitor.email === contact.EmailAddresses[0].Address) {
              self.UpdateVisitor(visitor, contact)
            }
          }
        })
    },
    getVisit: function () {
      var self = this
      return Q.Promise(function (resolve, reject, notify) {
        if (self.authorization === undefined && self.waitingForToken === false) {
          self.waitingForToken = true
          window.Office.context.auth.getAccessTokenAsync(function (result) {
            self.waitingForToken = false
            if (result.status === 'succeeded') {
              self.accessToken = result.value
              self.authorization = 'JWT ' + self.accessToken
            } else {
              self.authorization = 'EXJWT ' + self.callbackToken
            }
            self.getVisitWithToken()
              .then(function () {
                resolve()
              }, function (error) {
                console.error(error)
                reject()
              })
          })
        } else {
          self.getVisitWithToken()
            .then(function () {
              resolve()
            }, function (error) {
              console.error(error)
              reject()
            })
        }
      })
    },
    getVisitWithToken: function () {
      var self = this
      if (self.itemId === undefined) {
        // No itemId, so no visit can be found on Entrant
        return Q.Promise(function (resolve, reject, notify) {
          self.loading = false
          resolve()
        })
      }
      return Q.Promise(function (resolve, reject, notify) {
        axios
          .get('https://' + self.server + '/api/v1/visits/?uid_string=' + encodeURIComponent(self.itemId), {
            headers: {'Authorization': self.authorization},
          })
          .then(function (response) {
            if (response.data.count === 0) {
              self.visit = null
            }
            if (response.data.count === 1) {
              if (self.template === undefined) {
                // self.template = response.data.results[0].template

              }
              self.visit = response.data.results[0]
            }
            self.loading = false
            resolve()
          })
          .catch(function (error) {
            self.loading = false
            console.error(error)
          })
      })
    },
    SendVisitData: function () {
      var self = this
      self.sendVisit = false
      var host = axios
        .get('https://' + self.server + '/api/v1/hosts/?email=' + this.host_email, {
          headers: {'Authorization': self.authorization},
        })
      var visitors = axios
        .get('https://' + self.server + '/api/v1/visitors/', {
          headers: {'Authorization': self.authorization},
        })

      var visitorList = []
      Q.allSettled([
        host,
        visitors,
      ])
        .then(function (results) {
          // Create list of visitors from contacts
          var host = results[0].value.data
          var visitors = results[1].value.data.results
          var newVisitors = []
          if (self.contactsLoaded !== true) {
            console.error('Contacts not loaded!')
            self.updating = false
            return
          }
          self.missing_data = []
          for (var j = 0; j < self.contacts.length; j++) {
            var contact = self.contacts[j]
            var visitorId = null
            for (var i = 0; i < visitors.length; i++) {
              var visitor = visitors[i]
              if (visitor.email == null) { continue }
              if (visitor.email.toLowerCase() === contact.EmailAddresses[0].Address.toLowerCase()) {
                self.UpdateVisitor(visitor, contact)
                visitorId = visitor.id
                visitorList.push(visitor.id)
              }
            }
            if (visitorId === null) {
              newVisitors.push(self.CreateVisitor(contact))
            }
          }
          self.host = host.results[0]

          Q.allSettled(newVisitors)
            .then(function (results) {
              // Add newly created visitors to list
              for (var i = 0; i < results.length; i++) {
                visitorList.push(results[i].value.data.id)
              }

              self.loadVisitors()
                .then(function () {
                  self.PostVisit(visitorList)
                })
            })
        })
    },
    PostVisit: function (visitors) {
      var self = this
      var url = 'https://' + self.server + '/api/v1/visits/'
      var id = null
      var method = 'post'
      if (self.visit) {
        id = self.visit.id
        url = url + id + '/'
        method = 'put'
      }
      var data = {
        'id': id,
        'uid_string': this.itemId,
        'host': this.host.id,
        'visitors': visitors,
        'location': this.location,
        'purpose': this.subject,
        'start': this.start,
        'end': this.end,
        'template': this.template,
      }
      axios({
        method: method,
        url: url,
        data: data,
        headers: {'Authorization': self.authorization},
      })
        .then(function (response) {
          self.visit = response.data
          self.loading = false
          self.error = {}
        })
        .catch(function (error) {
          console.error(error.response)
          console.error(error.response.data)
          self.error = error.response.data
          self.loading = false
        })
    },
    CreateVisitor: function (contact) {
      var self = this
      return axios.post(
        'https://' + self.server + '/api/v1/visitors/',
        {
          'email': contact.EmailAddresses[0].Address,
          'firstname': contact.GivenName,
          'surname': contact.Surname,
          'company': contact.CompanyName,
          'mobile': contact.BusinessPhones[0],
        },
        {headers: {'Authorization': self.authorization}}
      )
    },
    UpdateVisitors: function () {
      var self = this
      if (self.contacts.length === 0) {
        self.error.visitors = true
      } else {
        self.error.visitors = null
      }
      var LocalMissingData = []
      for (var j = 0; j < self.contacts.length; j++) {
        var contact = self.contacts[j]
        for (var i = 0; i < self.visitors.length; i++) {
          var visitor = self.visitors[i]
          if (visitor.email === contact.EmailAddresses[0].Address) {
            var missing = self.UpdateVisitor(visitor, contact)
            if (missing === true) {
              LocalMissingData.push(contact)
            }
            break
          }
        }
      }
      self.missing_data = LocalMissingData
    },
    UpdateVisitor: function (visitor, contact) {
      // Sync contact data to Visitor
      var self = this
      var dirty = false
      var missing = false
      if (visitor.mobile === '' || typeof visitor.mobile !== 'string') {
        if (contact.BusinessPhones[0] !== '' &&
          typeof contact.BusinessPhones[0] === 'string' &&
          contact.BusinessPhones.length > 0) {
          visitor.mobile = contact.BusinessPhones[0]
          dirty = true
        } else {
          missing = true
        }
      }
      if (visitor.company === '' || typeof visitor.company !== 'string') {
        if (contact.CompanyName !== '' && typeof contact.CompanyName === 'string') {
          visitor.company = contact.CompanyName
          dirty = true
        } else {
          missing = true
        }
      }
      if (visitor.firstname === '' || typeof visitor.firstname !== 'string') {
        if (contact.GivenName !== '' && typeof contact.GivenName === 'string') {
          visitor.firstname = contact.GivenName
          dirty = true
        } else {
          missing = true
        }
      }
      if (visitor.surname === '' || typeof visitor.surname !== 'string' || visitor.surname === null) {
        if (contact.Surname !== '') {
          visitor.surname = contact.Surname
          dirty = true
        } else {
          missing = true
        }
      }
      if (dirty) {
        axios.put(
          'https://' + self.server + '/api/v1/visitors/' + visitor.id + '/',
          visitor,
          {headers: {'Authorization': self.authorization}}
        )
      }

      if (contact.GivenName === '') {
        contact.GivenName = visitor.firstname
      }
      if (contact.Surname === '') {
        contact.Surname = visitor.surname
      }
      if (contact.CompanyName === '') {
        contact.CompanyName = visitor.company
      }
      if (contact.BusinessPhones.length === 0) {
        contact.BusinessPhones[0] = visitor.mobile
      }
      return missing
    },
    CreateVisit: function () {
      var self = this
      this.loading = true
      this.created = true
      self.sendVisit = true
    },
    UpdateVisit: function () {
      var self = this
      // this.loading = true
      if (self.visit) {
        self.sendVisit = true
      }
    },
    SetTemplate: function (value) {
      this.template = value
    },
    AddWelcomeMessage: function () {
      var self = this
      var url = 'https://' + self.server + '/api/v1/emails/visit/' + self.visit.id + '/'
      axios
        .get(url, {
          headers: {'Authorization': self.authorization},
        })
        .then(function (response) {
          self.item.body.prependAsync(
            response.data.html_body,
            {coercionType: window.Office.CoercionType.Html}
          )
        })
    },
    SendWelcomeEmail: function () {
      var self = this
      var url = 'https://' + self.server + '/api/v1/emails/visit/' + self.visit.id + '/'
      axios
        .post(url, {}, {
          headers: {'Authorization': self.authorization},
        })
        .then(function (response) {
        })
    },
  },
  watch: {
    template: function (val) {
      this.UpdateVisit()
    },
  },
}
</script>

<style>
.full-col {
  width: 100%;
}
.ms-Grid-col {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue